import * as React from 'react';

import Icon from '../Icon';
import classNames from 'classnames';

interface ICartSubRow {
    label: string | React.ReactNode;
    value: string;
}
interface ICartTotalsRow {
    label: string | React.ReactNode;
    value: string;
    subrows?: ICartSubRow[];
    isIndented?: boolean;
    isPrimary?: boolean;
    isSeparated?: boolean;
    isAccented?: boolean;
}

export interface ICartTotalsProps {
    data: ICartTotalsRow[];
}

const CartTotals: React.FunctionComponent<ICartTotalsProps> = (props) => {
    return (
        <ul className="cart-prices">
            {props.data.map((row, i) => {
                if (!row) {
                    return (<React.Fragment/>);
                }
                return(
                    <CartRow key={i} {...row}/>
                );
            })}
        </ul>
    );
};

const CartRow: React.FunctionComponent<ICartTotalsRow> = (props) => {
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    return (
        <React.Fragment>
            <li className={classNames(props.isPrimary && 'primary', props.isSeparated && 'separated', props.isIndented && 'indented')}>
                <span className={classNames('label')}>
                    {props.label}:
                    {props.subrows && (<button onClick={() => { setIsOpen(!isOpen);}}><Icon kind={'arrow5-down'} width={12} height={12}/></button>)}
                </span>
                <span className={classNames('value',  props.isAccented && 'text-accented')}>
                    {props.value}
                </span>
            </li>
            {props.subrows && isOpen && props.subrows.map((row, i) => {
                if (!row) {
                    return (<React.Fragment/>);
                }
                return(
                    <CartRow key={i} {...row} isIndented={true}/>
                );
            })}
        </React.Fragment>

    );
};

CartTotals.displayName = 'CartTotals';

export default CartTotals;
